// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_download_modal_features_pro = /** @type {(inputs: {}) => string} */ () => {
	return `All platform monetization (no copyright claims)|Valid for multiple projects|School and University Projects|Blogs, Podcasts & Audiobooks|Track versions & loops`
};

const de_download_modal_features_pro = /** @type {(inputs: {}) => string} */ () => {
	return `Monetarisierung auf allen Plattformen (keine Copyright Claims)|Für mehrere Projekte gültig|Universitäts- und Schulprojekte|Blogs, Podcasts & Audiobooks|Liedvariationen & Loops`
};

const es_download_modal_features_pro = /** @type {(inputs: {}) => string} */ () => {
	return `Monetización en todas las plataformas (sin reclamaciones de derechos de autor) | Válido para múltiples proyectos|Proyectos escolares y universitarios|Blogs, podcasts y audiolibros|Versiones y loops de pistas`
};

const pt_br_download_modal_features_pro = /** @type {(inputs: {}) => string} */ () => {
	return `Monetização em todas as plataformas (sem reivindicações de direitos autorais) | Válido para vários projetos | Projetos escolares e universitários | Blogs, podcasts e audiolivros | Versões e loops da faixa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "pt-br" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const download_modal_features_pro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.download_modal_features_pro(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("download_modal_features_pro", locale)
	if (locale === "en") return en_download_modal_features_pro(inputs)
	if (locale === "de") return de_download_modal_features_pro(inputs)
	if (locale === "es") return es_download_modal_features_pro(inputs)
	return pt_br_download_modal_features_pro(inputs)
};
export { download_modal_features_pro as "download-modal.features.pro" }